import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const commissionService = createApi({
  reducerPath: 'commissionService',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['commissionList', 'vatList'],

  endpoints: (builder) => ({
    updateCommission: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/payment-service/v1/commission-config/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['commissionList'],
    }),

    getAllCommissions: builder.query({
      query: (params) => ({
        url: '/payment-service/v1/commission-config',
        method: 'GET',
        params,
      }),
      providesTags: ['commissionList'],
    }),

    updateVat: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/payment-service/v1/vat-config/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['vatList'],
    }),

    getAllVats: builder.query({
      query: (params) => ({
        url: '/payment-service/v1/vat-config',
        method: 'GET',
        params,
      }),
      providesTags: ['vatList'],
    }),
  }),
});

export const {
  useGetAllCommissionsQuery,
  useUpdateCommissionMutation,
  useGetAllVatsQuery,
  useUpdateVatMutation,
} = commissionService;
